// src/App.jsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LanguageSelection from './components/LanguageSelection';
import UserInfoForm from './components/UserInfoForm';
import AssessmentIntro from './components/AssessmentIntro';
import AssessmentQuiz from './components/AssessmentQuiz';
import ResultSubmission from './components/ResultSubmission';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LanguageSelection />} />
        <Route path="/interview" element={<UserInfoForm />} />
        <Route path="/intro" element={<AssessmentIntro />} />
        <Route path="/quiz" element={<AssessmentQuiz />} />
        <Route path="/submit" element={<ResultSubmission />} />
      </Routes>
    </Router>
  );
}

export default App;
